<template>
  <embed :src="file" type="application/pdf" style="overflow: auto" height="100%" width="100%" />
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "embed-view",
  props: {
    file: { type: String, default: "" },
  },
});
</script>
